import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, EnvelopeIcon, ClockIcon } from '@heroicons/react/24/outline';

const Footer = () => {
  const locations = [
    {
      name: 'Power Studio Plaza',
      address: 'Plaza Shopping Center, Casablanca',
      phone: '+212 5XX-XXX-XXX'
    },
    {
      name: 'Pulse Studio Plaza',
      address: 'Plaza Shopping Center, Casablanca',
      phone: '+212 5XX-XXX-XXX'
    },
    {
      name: 'Vitality Studio Plaza',
      address: 'Plaza Shopping Center, Casablanca',
      phone: '+212 5XX-XXX-XXX'
    }
  ];

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex flex-row items-center mb-4">
              <img
                className="h-24 w-auto mx-auto"
                src="/assets/icons/nazai-studio-logo.png"
                alt="Nazaï Studio"
              />
            </div>
            <p className="text-white mb-4">
              Votre coach est à l'écoute de vos besoins, pour personnaliser le coaching. 
              Boxe, Muay Thai, Kick Boxing - Cours privés professionnels.
            </p>
            <div className="flex items-center text-white mb-2">
              <ClockIcon className="h-5 w-5 mr-2" />
              <span>Lun - Dim: 8h00 - 21h00</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="">
            <h3 className="text-lg font-semibold text-red-500 mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white hover:text-white transition-colors duration-200">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white hover:text-white transition-colors duration-200">
                  Services & Tarifs
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-white hover:text-white transition-colors duration-200">
                  Réserver une séance
                </Link>
              </li>
              <li>
                <Link to="/profile" className="text-white hover:text-white transition-colors duration-200">
                  Mon compte
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="text-white hover:text-white transition-colors duration-200">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-white hover:text-white transition-colors duration-200">
                  Règles de confidentialité
                </Link>
              </li>
            </ul>
          </div>

          
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-white text-sm mb-4 md:mb-0">
              © 2025 Nazaï Studio. Tous droits réservés.
            </div>
            <div className="flex items-center space-x-4">
              <a
                href="mailto:contact@nazaistudio.com"
                className="flex items-center text-white hover:text-white transition-colors duration-200"
              >
                <EnvelopeIcon className="h-4 w-4 mr-2" />
                <span className="text-sm">contact@nazaistudio.com</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
